export function validateEmail(email) {
  const format =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return format.test(email);
}

export function validatePhoneNumber(phone) {
  const format = /^\d{10}$/;

  return format.test(phone);
}

export function checkPhoneNumber(input_str) {
  var re = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;

  return re.test(input_str);
}

export const checkNameRegex = (name) => {
  const nameRegex = /^(?! *$)[a-zA-Z ]+(?: [a-zA-Z ]+)*$/;
  return nameRegex.test(name);
};

export const checkUniversalPhoneNumber = (number) => {
  const phoneRegex =
    /^\+?(?:\d{1,3}[\s-]?)?(?:\(\d{1,4}\)|\d{1,4})[\s-]?\d{1,4}[\s-]?\d{1,4}$/;
  return phoneRegex.test(number);
};

export const checkStringIsNumberOnly = (string) => {
  const numberOnlyReg = /^\d+$/;
  return numberOnlyReg.test(string);
};

export const trimObjectValues = (obj) => {
  const values = {};
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      values[key] = obj[key].trim();
    }
  }
  return values;
};

